import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { PageHeader } from "@/components/common/PageHeader";
import { Loader } from "@/components/common/Loader";
import { Button } from "@/components/ui/button";
import { ActivityItem } from "@/components/common/ActivityItem";
import { Mail, Phone, ShieldCheck, User as UserIcon, LogOut, Activity as ActivityIcon } from "lucide-react";

export default function More() {
  const { user, logout, isLeader } = useAuth();
  const [acts, setActs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/activities?limit=25")
      .then((res) => setActs(res.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="animate-fade-in-up space-y-6">
      <PageHeader title="Profile & Activity" subtitle="Your account and recent actions" />

      <div className="rounded-xl border border-border bg-card p-5 shadow-card">
        <div className="flex items-center gap-4">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-xl font-bold text-primary-foreground">
            {(user?.full_name || "?").slice(0, 1)}
          </div>
          <div className="min-w-0">
            <div className="text-lg font-bold text-foreground">{user?.full_name}</div>
            <span className="mt-0.5 inline-flex items-center gap-1 rounded-full bg-accent px-2 py-0.5 text-xs font-semibold text-accent-foreground">
              {isLeader ? <ShieldCheck className="h-3 w-3" /> : <UserIcon className="h-3 w-3" />}
              {isLeader ? "Team Leader" : "Employee"}
            </span>
          </div>
        </div>
        <div className="mt-4 grid gap-2 text-sm">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Mail className="h-4 w-4" /> {user?.email}
          </div>
          {user?.phone && (
            <div className="flex items-center gap-2 text-muted-foreground">
              <Phone className="h-4 w-4" /> {user.phone}
            </div>
          )}
        </div>
        <Button variant="outline" className="mt-5 w-full text-destructive hover:text-destructive" onClick={logout}>
          <LogOut className="h-4 w-4" /> Sign out
        </Button>
      </div>

      <section>
        <h2 className="mb-2.5 flex items-center gap-1.5 text-sm font-semibold text-muted-foreground">
          <ActivityIcon className="h-4 w-4" /> Recent activity
        </h2>
        {loading ? (
          <Loader />
        ) : acts.length ? (
          <div className="overflow-hidden rounded-xl border border-border bg-card shadow-card">
            {acts.map((a) => <ActivityItem key={a.id} activity={a} />)}
          </div>
        ) : (
          <p className="rounded-xl border border-dashed border-border p-6 text-center text-sm text-muted-foreground">
            No recent activity yet.
          </p>
        )}
      </section>
    </div>
  );
}
